/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingfbpageposthint4Inputs */

const en_crosspostingfbpageposthint4 = /** @type {(inputs: Crosspostingfbpageposthint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text, an optional link, and up to 10 images.`)
};

const de_crosspostingfbpageposthint4 = /** @type {(inputs: Crosspostingfbpageposthint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text, optionaler Link und bis zu 10 Bilder.`)
};

/**
* | output |
* | --- |
* | "Text, an optional link, and up to 10 images." |
*
* @param {Crosspostingfbpageposthint4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingfbpageposthint4 = /** @type {((inputs?: Crosspostingfbpageposthint4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingfbpageposthint4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingfbpageposthint4(inputs)
	return de_crosspostingfbpageposthint4(inputs)
});
export { crosspostingfbpageposthint4 as "crosspostingFbPagePostHint" }